export default {
    authByCode: 'nomanage/login',


    addProject: 'web/project/add',
    myProject: 'web/project/myProjects',
    deleteProject: 'web/project/del',
    completeProject: 'web/project/projectOver',
    completeProjectList: 'web/project/getFinishProjectList',
    undoCompleteProject: 'web/project/backFinishedProject',
    projectDetail: 'web/project/detail',
    editProject: 'web/project/update',

    taskType: 'web/taskType/getTypeList',
    getTaskTypeByProject: 'web/taskType/getListByProject',
    deleteTaskType: 'web/taskType/del',
    addTaskType: 'web/taskType/add',
    editTaskType: 'web/taskType/update',
    getTaskType: 'web/taskType/getFieldByType',
    getTypeList: '/web/taskType/getTypeList',
    taskCustomList: 'web/taskTypeFiled/getAll',

    addTask: '/web/task/add',
    editTask: '/web/task/update',
    exportTask: 'web/task/export',
    myTask: 'web/task/myTaskList',
    subTask: 'web/task/getSubTaskList',
    getTaskByProject: 'web/task/projectTaskList',
    getTaskPanel: 'web/task/getBoardList',
    deleteTask: 'web/task/del',
    toggleSubTask: 'web/task/relateTask',
    relativeEnable: 'web/task/relateTaskList',
    updateTaskStatus: 'web/task/updateTaskStatus',
    updateTaskGroup: 'web/task/updateTaskGroup',
    taskDetail: 'web/task/detail',

    tag: 'projectLabel/getLabelList',
    updateTag: 'projectLabel/update',

    getGroup: 'web/projectGroup/getGroupsByProject',
    addGroup: 'web/projectGroup/add',
    deleteGroup: 'web/projectGroup/del',
    updateGroup: 'web/projectGroup/update',

    getUserListByAddition: 'web/taskUser/getUserListByAddition',

    followProject: 'web/projectDashBoard/centerList',
    follow: 'web/project/updateSaveStatus',

    upload: 'web/taskFile/uploadProjectTaskFile',


    constant: 'rule/r-dict/find',
    company: 'web/taskUser/getDeptListByAddition',

    download: 'web/downTaskFile',

    addProcessComment: 'web/taskProgress/add',
    addCommentComment: 'web/task/addComment',
    comment: 'web/taskProgress/progressList',

    getUserInfoByUserId: 'authority/hbc/getUserByLoginId',

    nui: {
        common: {
            upload: 'api/Attachment/Upload',
            address: 'api/AreaSelect/getlist/'
        }
    }
};
